import { SET_ERROR, CLOSE_ERROR } from "./type";

export const setError = (error) => ({ type: SET_ERROR, payload: error });

export const closeError = () => ({ type: CLOSE_ERROR });
